import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import Layout from '@components/common/Layout';
import HomeBottomArea from '@container/home/elements/HomeBottomArea';

const Home = () => {
  const { getChildrenMenus } = $hooks.useTabletRouterUtils();
  const {
    router: {
      location: { pathname },
    },
  } = useSelector(state => state);

  const childrenMenus = getChildrenMenus('/home');
  const homeMainPath = childrenMenus?.[0];
  const isHomeMainPage = pathname === '/home/main';

  return (
    <Layout bottomStepArea={isHomeMainPage ? null : <HomeBottomArea />}>
      <Switch>
        {childrenMenus.map((menu, index) => (
          <Route key={index} path={menu.path} component={menu.component} />
        ))}

        {homeMainPath && <Redirect to={homeMainPath.path} />}
      </Switch>
    </Layout>
  );
};

export default Home;
